<mat-drawer-container class="drawer-container">
  <administration></administration>
  <mat-tab-group
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    fxFlexFill
    [selectedIndex]="(selectedIndex$ | async) || 0"
    (selectedIndexChange)="onTabChange($event)"
  >
    <mat-tab label="Roles">
      <roles #roles (updateDrawerContent)="updateDrawerContent($event)"></roles>
    </mat-tab>
    <mat-tab label="User Collections">
      <userCollections #userCollections (updateDrawerContent)="updateDrawerContent($event)"></userCollections>
    </mat-tab>
    <mat-tab label="OU Collections">
      <ou-collections #ouCollections (updateDrawerContent)="updateDrawerContent($event)"></ou-collections>
    </mat-tab>
    <mat-tab label="Designations">
      <designations #designations (updateDrawerContent)="updateDrawerContent($event)"></designations>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="new-collection-dropdown-container">
          <lib-cdw-icon
            *ngIf="selectedIndex === 1"
            class="info-icon"
            [icon]="'info'"
            [useMatIcon]="false"
            [customColor]="tertiaryBlueCta"
            size="30px"
            [matTooltip]="'Creating user collections is optional. A user collection is a group of users that share similar access needs, making it easier to manage permissions across many team members at once.'"
            matTooltipPosition="above"
            (click)="$event.stopPropagation()">
          </lib-cdw-icon>
          <lib-cdw-dropdown-menu
            *ngIf="selectedIndex === 1"
            [buttonLabel]="'Add new user collection(s)'"
            [fontFamily]="'Roboto'"
            [fontSize]="'14px'"
            [fontWeight]="700"
            paddingLeft="1rem"
            [options]="userCollectionMenuOptions"
            [buttonColor]="tertiaryBlueCta"
            [dropdownArrowPosition]="'right'"
            [panelPosition]="'before'"
            [panelWidth]="'280px'"
            (optionSelected)="onUserCollectionMenuSelect($event)">
          </lib-cdw-dropdown-menu>
          <lib-cdw-button
            fontWeight="700"
            fontFamily="Roboto"
            *ngIf="selectedIndex !== 1"
            [customColor]="tertiaryBlueCta"
            (buttonClick)="newButtonClick()">
            {{ getNewButtonText() }}
          </lib-cdw-button>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
  <lib-cdw-drawer
    drawerId="accessManagementDrawer"
    [toolbarTitle]="accessManagementDrawerTitle"
    [toolbarSubtitle]="accessManagementDrawerSubtitle"
    [drawerWidth]="'350px'"
    [toolbarTitleBackground]="gray50"
    toolbarTitleFontSize="20px"
    toolbarSubtitleFontSize="24px"
    toolbarTitleFontWeight="800"
    toolbarSubtitleFontWeight="800"
    [toolbarTitleColor]="gray300"
    [toolbarSubtitleColor]="tertiaryBlueCta"
    toolbarTitleFontFamily="Source Sans 3"
    toolbarSubtitleFontFamily="Source Sans 3"
  >
    <lib-cdw-drawer-content
      drawerContentId="accessManagementSummaryDrawerContent"
      [contentTitle]="accessManagementDrawerTitle"
      [noContentMessage]="'No content'"
      [drawerContents]="drawerContent"
      [deleteLabel]="getDeleteLabel()"
      [disableDelete]="isDeleteDisabled()"
      [disableEdit]="currentItemType === 'orgUnit'"
      [hasSubtitle]="!!accessManagementDrawerSubtitle"
      (deleteClicked)="deleteAccessManagementItem()"
      (editClicked)="editAccessManagementItem()"
    >
    </lib-cdw-drawer-content>
  </lib-cdw-drawer>
</mat-drawer-container>
